import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./styles.module.scss";
import H2Font from "Root/profile/components/common/H2Font";
import React from "react";
const VideoQuestion = ({ text, video }) => {
    return (_jsxs("div", { className: styles.video_question, children: [_jsx(H2Font, { children: text }), _jsx("div", { className: styles.video, children: _jsx("video", { controls: true, src: video, preload: "metadata", children: _jsx("track", { src: "", kind: "captions", srcLang: "en", label: "english_captions" }) }) })] }));
};
export default VideoQuestion;
